<div class="multiple-choice" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="20px" fxFill>
  <form [formGroup]="multipleChoiceForm" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="20px">
    <dashboard-module-item-core [dialogData]="dialogData" formControlName="moduleItemCore"></dashboard-module-item-core>
    <div fxLayout="column">
      <mat-tab-group
        mat-align-tabs="end"
        animationDuration="0ms"
        (selectedTabChange)="dashboardModuleItemCore.selectTemplateLanguage($event); emitPreviewValues()"
        [disablePagination]="true"
        [selectedIndex]="selectedLanguage?.tabIndex"
      >
        <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
          <ng-template matTabContent>
            <div formArrayName="translations" *ngFor="let item of translations?.controls; let i = index">
              <mat-form-field
                [formGroupName]="i"
                fxFill
                *ngIf="
                  item.get('language').value === selectedLanguage?.code &&
                  item.get('identifier').value === MODULE_ITEM_CHOICES_IDENTIFIER
                "
              >
                <label class="multiple-choice__label">Choices (write each choice in new line)</label>
                <textarea class="multiple-choice__field" matInput rows="5" formControlName="translation"></textarea>
              </mat-form-field>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div fxLayout="column" fxLayoutAlign="space-between stretch">
      <mat-form-field>
        <input type="number" matInput formControlName="minAnswers" placeholder="Minimum number of answers" />
        <mat-error *ngIf="minAnswers.hasError('min')">
          Minimum number of answers needs to be greater than 0.
        </mat-error>
      </mat-form-field>
    </div>
    <div fxLayout="column" fxLayoutAlign="space-between stretch">
      <mat-form-field>
        <input type="number" matInput formControlName="maxAnswers" placeholder="Maximum number of answers" />
      </mat-form-field>
    </div>
    <mat-checkbox formControlName="randomize">Randomize choices</mat-checkbox>
    <mat-checkbox formControlName="allowOther">Allow other option</mat-checkbox>
  </form>
  <div
    class="multiple-choice__actions"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.ALL)"
  >
    <button mat-raised-button color="primary" (click)="closeModuleItemDialog()">
      {{ 'Cancel' | uppercase }}
    </button>
    <button mat-raised-button color="primary" (click)="saveModuleItem()">
      {{ 'Save' | uppercase }}
    </button>
  </div>
</div>
